/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface ITransferableSkillsChecklist {
        assessmentName: string;
        assessmentId: number;
        currentSession: IAssessmentSession;
        assessment: IAssessment;
        questions: IQuestion[];
        totalQuestions: number;
        totalPages: number;
        sessions: IAssessmentSession[];
        nextPageLink: string;
        prevPageLink: string;
        assessmentResults: ICareerClusterResult[];
        progressGauge: any;
        inProgress: boolean;
        state: State;
        loading: boolean;
        rankedResults: any;
        answers: IAnswer[];
    }

    interface ICareerClusterResult {
        careerCluster: ICareerCluster;
        count: number;
    }

    interface ICareerCluster {
        id: number;
        title: string;
        description: string;
        code: number;
    }

    class State {
        step: number;
        sessionId?: number;
        categoryIndex: number;
    }


    class TransferableSkillsChecklist implements ITransferableSkillsChecklist {
        static controllerId: string = "transferableSkillsChecklist";
        static $inject: string[] = ["$scope", "common", "Restangular", "$q", "$location", "$routeParams"];

        assessmentName: string = "transferable-Skills-Checklist";
        assessmentId = 4;
        currentSession: IAssessmentSession;
        assessment: IAssessment;
        questions: IQuestion[];
        totalQuestions: number;
        totalPages: number;
        sessions: IAssessmentSession[];
        nextPageLink: string;
        prevPageLink: string;
        assessmentResults: ICareerClusterResult[];
        progressGauge: any;
        inProgress: boolean;
        categories: any;
        levels: any[];
        state: State = new State();
        loading: boolean = true;
        rankedResults: any;
        answers: IAnswer[];

        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;

        constructor(private $scope: ng.IScope, private common: ICommonFactory, private Restangular: Restangular.IService, private $q: ng.IQService,
            private $location: ng.ILocationService, private $routeParams: angular.route.IRouteParamsService) {

            this.log = common.logger.getLogFn(TransferableSkillsChecklist.controllerId);
            this.logError = common.logger.getLogFn(TransferableSkillsChecklist.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(TransferableSkillsChecklist.controllerId, "success");

            this.common.authentication.authenticate(true).then(() => {
                this.activate();

                if (this.$location.state()) {
                    this.state = this.$location.state();
                } else {
                    this.saveState(1, null, 0).replace();
                }

                this.questions = [];
                this.progressGauge = this.gaugeOptions;
                this.totalPages = 25;

                this.$scope.$on("$routeUpdate", () => {
                    if (this.$location.state()) {
                        this.state = this.$location.state();
                    }
                });

                this.activate();
            });
        }


        activate() {
            var promises: ng.IPromise<any>[] = [this.getAssessment(), this.getCategories()];

            this.common.activateController(promises, TransferableSkillsChecklist.controllerId)
                .then(() => {
                    if (this.state.step && this.state.sessionId && this.state.step == 3) {
                        this.getResults(this.state.sessionId);
                    }
                    else if (this.state.step && this.state.step == 2) {
                        this.startOrResumeSession();
                    }

                    if (this.sessions == null) {
                        this.getSessions();
                    }

                    this.loading = false;
                });
        }

        saveState(step?: number, sessionId?: number, categoryIndex?: number) {
            return this.$location.state({
                step: step ? step : this.state.step ? this.state.step : 1,
                sessionId: sessionId ? sessionId : this.currentSession ? this.currentSession.id : null,
                categoryIndex: categoryIndex != null ? categoryIndex : this.state.categoryIndex ? this.state.categoryIndex : 0
            });
        }

        deleteSession(): ng.IPromise<void> {
            var defer = this.$q.defer<void>();

            var inProgressSession = _.find(this.sessions, (s) => s.isComplete == false);

            if (inProgressSession) {
                this.Restangular.one("assessments", this.assessmentId).one("sessions", inProgressSession.id).remove()
                    .then(() => defer.resolve(),
                        (reason) => {
                            this.logError(reason.message, reason, true);
                        });
            }
            else {
                defer.resolve();
            }

            return defer.promise;
        }

        getAssessment(): ng.IPromise<void> {
            return this.Restangular.one("assessments", this.assessmentId).get<IAssessment>()
                .then((result) => {
                    this.assessment = result;
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        getSessions(): ng.IPromise<void> {
            return this.Restangular.one("assessments", this.assessmentId).one("sessions").get<IAssessmentSession[]>()
                .then((sessions: IAssessmentSession[]) => {
                    this.sessions = sessions;
                    this.inProgress = _.some(this.sessions, (s) => s.isComplete == false);
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        getCurrentSession(): ng.IPromise<IAssessmentSession> {
            return this.Restangular.one("assessments", this.assessmentId).one("session").get<IAssessmentSession>();
        }

        getQuestions(categoryId: number): ng.IPromise<void> {
            var questions: ng.IPromise<any>;
            return this.Restangular.one("assessments", this.assessmentId).one("questions").get<IRestResult<IQuestion[]>>({ categoryId: categoryId, pageSize: 100 })
                .then((result: IRestResult<IQuestion[]>) => {
                    this.questions = result.results;
                    this.nextPageLink = result.nextPageLink;
                    this.prevPageLink = result.prevPageLink;
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        getResults(sessionId: number): ng.IPromise<void> {
            return this.Restangular.one("assessments", this.assessmentId).one("sessions", sessionId).one("answers").get({ includeQuestion: true })
                .then((results) => {
                    this.saveState(3, sessionId);
                    this.answers = results;
                },
                    (reason) => {
                        this.logError(reason.message, reason, false);
                    });

        }

        getCategories(): ng.IPromise<any> {
            return this.Restangular.one("assessments", this.assessmentId).one("categories").get()
                .then((result) => {
                    this.categories = result;
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        complete(): ng.IPromise<void> {
            return this.Restangular.one("assessments", this.assessmentId).one("sessions", this.currentSession.id).one("complete").put()
                .then(() => {
                    this.getResults(this.currentSession.id);
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        startOrResumeSession(): ng.IPromise<void> {
            var currentSession = this.getCurrentSession().then(result => {
                this.currentSession = result;
                this.progressGauge = this.gaugeOptions;
                this.currentSession.answers = this.currentSession.answers || [];
            }, (reason) => {
                this.logError(reason.message, reason, true);
            });
            var categoryId = this.categories[this.state.categoryIndex].id
            var questions = this.getQuestions(categoryId);

            return this.$q.all<void, void>([currentSession, questions])
                .then(() => {
                    this.selectAnswers();
                    this.saveState(2, this.currentSession.id);
                    this.updateProgressIndicator(this.state.categoryIndex);
                });
        }

        selectAnswers() {
            var answers = this.currentSession.answers;
            this.questions.forEach(function (q: IQuestion, i: number) {
                var answer = _.find<IAnswer>(answers, { questionId: q.id });
                if (answer) {
                    this[i].selected = parseInt(answer.answer);
                }
            }, this.questions);

        }

        startOver() {
            this.deleteSession()
                .then(() => {
                    this.currentSession = null;
                    this.state.categoryIndex = 1;
                    this.startOrResumeSession();
                });
        }


        toggleAnswer(question: IQuestion) {
            var idx = _.findIndex<IAnswer>(this.currentSession.answers, { questionId: question.id } as IAnswer);
            if (idx == -1) {
                var answer: IAnswer = {
                    id: null,
                    sessionId: this.currentSession.id,
                    assessmentId: this.assessmentId,
                    questionId: question.id,
                    categoryId: question.categoryId,
                    interestAreaId: null,
                    answer: "1"
                };
                this.Restangular.one("assessments", this.assessmentId).one("sessions", this.currentSession.id)
                    .one("questions", question.id).all("answers").post(answer)
                    .then((result) => {
                        answer.id = result;
                        this.currentSession.answers.push(answer);
                    }, (reason) => {
                        this.logError(reason.message, reason, true);
                    });
            } else {
                var answer = this.currentSession.answers.splice(idx, 1)[0];
                this.Restangular.one("assessments", this.assessmentId).one("sessions", this.currentSession.id)
                    .one("questions", question.id).one("answers", answer.id).remove()
                    .then(null, (reason) => {
                        this.logError(reason.message, reason, true);
                    });
            }

            this.selectAnswers();
        }


        nextPage() {
            var categoryIdx = this.state.categoryIndex + 1;

            var categoryId = this.categories[categoryIdx].id
            this.getQuestions(categoryId)
                .then(() => {
                    this.selectAnswers();
                    this.saveState(null, null, categoryIdx)
                    this.updateProgressIndicator(categoryIdx);
                });
        }

        prevPage() {
            var categoryIdx = this.state.categoryIndex - 1;

            var categoryId = this.categories[categoryIdx].id
            this.getQuestions(categoryId)
                .then(() => {
                    this.selectAnswers();
                    this.saveState(null, null, categoryIdx)
                    this.updateProgressIndicator(categoryIdx);
                });
        }

        updateProgressIndicator(page) {
            this.progressGauge.series[0].data[0].y = Math.ceil((page / this.totalPages) * 100);
        }

        showCategoryInResults(category: IAssessmentCategory) {
            return _.some(this.answers, { categoryId: category.id });
        }


        get gaugeOptions() {
            return {
                title: {
                    text: null
                },
                chart: {
                    type: 'solidgauge',
                    height: 150
                },
                pane: {
                    startAngle: 0,
                    endAngle: 360,
                    background: [{ // Track for Move
                        outerRadius: '100%',
                        innerRadius: '0%',
                        borderWidth: 0
                    }]
                },
                yAxis: {
                    min: 0,
                    max: 100,
                    lineWidth: 0,
                    tickPositions: []
                },
                plotOptions: {
                    solidgauge: {
                        dataLabels: {
                            enabled: true,
                            borderWidth: 0,
                            format: "{y}%",
                            x: 0,
                            y: -15,
                            padding: 0,
                            useHTML: true,
                            style: {
                                fontSize: "20px"
                            }
                        }
                    }
                },
                tooltip: {
                    borderWidth: 0,
                    backgroundColor: 'none',
                    shadow: false,
                    pointFormat: ""
                },
                series: [{
                    name: 'Progress',
                    data: [{
                        color: '#FA9C4B',
                        radius: '100%',
                        innerRadius: '0%',
                        y: 0
                    }]
                }]
            };
        }


    }

    angular.module("app").controller(TransferableSkillsChecklist.controllerId, TransferableSkillsChecklist);
}